<template>
  <div class="form-group">
    <label for="report_option_customer_segment">Choose Customer Segment</label>
    <select
      id="report_option_customer_segment"
      v-model="value.id"
      class="form-control"
      @change="markCompleted()"
    >
      <option v-if="customerSegments.length > 1" disabled :value="null">
        -- Select One --
      </option>
      <option v-if="allAllowed && customerSegments.length > 1" value="">
        All Customer Segments
      </option>
      <option
        v-for="theCustomerSegment in customerSegments"
        :key="`customer-segment-${theCustomerSegment.id}`"
        :value="theCustomerSegment.id"
      >
        {{ theCustomerSegment.name }}
      </option>
    </select>
  </div>
</template>

<script>
import ProvidesCompletedOptionTracking from "./ProvidesCompletedOptionTracking";

export default {
  mixins: [ProvidesCompletedOptionTracking],

  props: {
    value: {
      required: true,
      type: Object,
    },

    customerSegments: {
      required: true,
      type: Array,
    },

    allAllowed: {
      type: Boolean,
      default: true,
    },
  },

  created() {
    this.initializeCompletedTracking();

    // when swapping between two instances of this - one with all allowed and one without,
    // its possible to have a 'value' of 'all' (which is empty string) selected in an all-allowed
    // and then swapping to a non-all-allowed where that value is unable to be triggered
    // if you find yourself copy/pasting this again, time to make a mixin
    if (!this.allAllowed && this.value.id === "") {
      this.value.id = null;
    }

    if (this.value.id !== null) {
      this.markCompleted();
    } else if (this.customerSegments.length === 1) {
      this.value.id = this.customerSegments[0].id;
      this.markCompleted();
    }
  },

  mounted() {
    this.$emit("loaded");
  },
};
</script>
